import { CARRIER_BRIDGE_LABEL } from "kontrolEdge/helpers/carrierBridgeName";

/** Every visible string of the Carriers admin screens (CTX-786), in one place. */
export const carriersAdminText = {
  searchPlaceholder: "Find by attribute or value",
  addButton: "Add Carrier",
  noCode: "-",
  available: { yes: "Yes", no: "No" },
  columns: {
    name: "Name",
    code: "Code",
    available: "Available",
    services: `${CARRIER_BRIDGE_LABEL} services`,
    actions: "Actions",
  },
  modal: {
    createTitle: "Add Carrier",
    editTitle: "Edit Carrier",
    name: "Name",
    code: "Code (optional, up to 32 characters)",
    available: `Available for new ${CARRIER_BRIDGE_LABEL} services`,
    availableHint: `When off, the carrier disappears from the ${CARRIER_BRIDGE_LABEL} form. The services that already use it keep it.`,
    cancel: "Cancel",
    save: "Save",
  },
  delete: {
    title: (name: string) => `Delete ${name}?`,
    description: `No ${CARRIER_BRIDGE_LABEL} service uses it. It will no longer be offered in the ${CARRIER_BRIDGE_LABEL} form.`,
    confirm: "Delete",
    cancel: "Cancel",
    inUseTitle: (name: string) => `${name} can't be deleted`,
    inUseDescription: (count: number) =>
      `It is used by ${count} ${CARRIER_BRIDGE_LABEL} service${count === 1 ? "" : "s"}. Deactivate it instead: it stops being offered for new services, and the existing ones keep it.`,
    deactivate: "Deactivate",
    failedTitle: "The carrier could not be changed",
    failedConfirm: "Got it",
  },
} as const;
